import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import NavBar from "../Navbar/Navbar.js";
import Header from '../Header/Header.js';
import { useUser } from '../UserContext';
import * as XLSX from 'xlsx';
import axiosInstance from '../axiosConfig.js';
import './Fortotikes.css';
import Multiselect from "multiselect-react-dropdown";
import { hideLoading, showLoading } from '../store/loadingSlice.js';
import { useTranslation } from "react-i18next";
import { FaCloudDownloadAlt } from 'react-icons/fa';

function ListaFortotikon() {
  const { t } = useTranslation();
  const [isNavOpen, setIsNavOpen] = useState(true);
  const { username, companyName } = useUser();
  const dispatch = useDispatch();
  const staticData = useSelector((state) => state.static.static);
  const licenseData = useSelector((state) => state.liscence.modules);
  const stateOptions = [
    { name: "Αδρομολόγητο", id: "10" },
    { name: "Σε Διανομή", id: "20" },
    { name: "Παραδόθηκε", id: "30" }
  ];

  const [fortotikes, setFortotikes] = useState([]);
  const [filters, setFilters] = useState({
    state: [],
    fromdate: getCurrentMonthStart(),
    todate: getCurrentMonthEnd(),
  });
  // PAGINATION
  const [totalPages, setTotalPages] = useState(1);
  const [currentPage, setCurrentPage] = useState(1);
  const [pagefrom, setPageFrom] = useState(1);
  const [pageto, setPageTo] = useState(20); 

  const handleNextPage = () => {
    if (currentPage < totalPages) {
      setPageFrom((prev) => prev + 20);
      setPageTo((prev) => prev + 20);
      setCurrentPage((prev) => prev + 1);
    }
  };

  const handlePreviousPage = () => {
    if (currentPage > 1) {
      setPageFrom((prev) => Math.max(1, prev - 20));
      setPageTo((prev) => Math.max(20, prev - 20));
      setCurrentPage((prev) => prev - 1);
    }
  };

  useEffect(() => {
    getFortotikes(pagefrom, pageto);
  }, [pagefrom, pageto]);

  function getCurrentMonthStart() {
    const date = new Date();
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
  }

  function getCurrentMonthEnd() {
    const date = new Date();
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
  }

  const toggleNav = () => {
    setIsNavOpen(!isNavOpen);
  };

  const formatDateForAPI = (dateStr) => {
    return dateStr.replace(/-/g, '');
  };

  const getFortotikes = async () => {
    try {
      dispatch(showLoading());

      // Extract selected state IDs
      let selectedStateIds = filters.state.map((state) => state.id).join(",");

      // If no states are selected, include all possible state IDs
      if (!selectedStateIds) {
        selectedStateIds = stateOptions.map((state) => state.id).join(",");
      }

      const thisClientID = localStorage.getItem("token");
      const parameters = {
        url: `https://${licenseData.company_url}/s1services`,
        service: "SqlData",
        clientID: thisClientID,
        appId: "1001",
        SqlName: "10022",
        company: licenseData.company_id,
        fromdate: formatDateForAPI(filters.fromdate),
        todate: formatDateForAPI(filters.todate),
        afm: licenseData.afm,
        state: selectedStateIds,
        pagefrom: String(pagefrom),
        pageto: String(pageto),
      };

      const response = await axiosInstance.post("/api", parameters);
      if (response && response.data) {        
        // Assuming rowcount1 is part of each row returned
        const totalRows = response.data.rows[0]?.ROWCOUNT1 || 0;
        console.log(totalRows);
        setTotalPages(totalRows > 0 ? Math.ceil(totalRows / 20) : 1);
        console.log(response.data.rows);
        setFortotikes(response.data.rows);
        ///return response;
      }else{
        setFortotikes([]);
      }
    } catch (error) {
      console.error("Error fetching fortotikes:", error);
      alert(t("errorFetchingData"));
      return null;
    } finally {
      dispatch(hideLoading());
    }
  };
  
  useEffect(() => {
    getFortotikes();
  }, []);

  const loadFortotikes = async () => {
    const resp = await getFortotikes();
    if (resp && resp.data.success) {
      setFortotikes(resp.data.rows);  // Update fortotikes state with new data
    } else if (resp && resp.data.error) {
      alert(resp.data.error);
    }
  };

  const handleFilterChange = (e) => {
    const { name, value } = e.target;
    setFilters({
      ...filters,
      [name]: value,
    });
  };

  const handleStateSelect = (selectedList) => {
    setFilters((prevFilters) => ({
      ...prevFilters,
      state: selectedList,  // Ensure state updates dynamically
    }));
  };
  
  const handleStateRemove = (selectedList) => {
    setFilters((prevFilters) => ({
      ...prevFilters,
      state: selectedList,  // Ensure state updates dynamically
    }));
  };

  const applyFilters = () => {
    setPageFrom(1);
    setPageTo(20);
    setCurrentPage(1);
    loadFortotikes();
  };
  
  const handlePrintDocument = async (findoc) => {
    try {
      dispatch(showLoading());
  
      const thisClientID = localStorage.getItem("token");
      const parameters = {
        url: `https://${licenseData.company_url}/s1services/JS/MyWS/PrintS1Template`,
        clientID: thisClientID,
        ObjectName: "SALDOC",
        FormName: "",
        RecordID: findoc,
        //TemplateCode: 4004, //να το ορίζουμε τοπικά στο Advanced Javascript Editor της κάθε εγκατάστασης
      };
  
      const response = await axiosInstance.post("/api", parameters);
  
      if (response.status === 200 && response.data) {
        window.open(response.data, "_blank");
      } else {
        alert(t("errorDownloadingDocument"));
      }
    } catch (error) {
      console.error("Error downloading document:", error);
      alert(t("errorDownloadingDocument"));
    } finally {
      dispatch(hideLoading());
    }
  };
  

  const exportToExcel = async () => {
    try {
      dispatch(showLoading());
      
      // First get the total row count from current state
      // This should match what's shown in your pagination UI
      const totalRows = fortotikes[0]?.ROWCOUNT1 || 0;
      
      if (totalRows === 0) {
        alert(t("noDataToExport"));
        return;
      }
  
      console.log(`Total rows in UI: ${totalRows}`);
  
      // Extract selected state IDs
      let selectedStateIds = filters.state.map((state) => state.id).join(",");
      if (!selectedStateIds) {
        selectedStateIds = stateOptions.map((state) => state.id).join(",");
      }
  
      const thisClientID = localStorage.getItem("token");
      const parameters = {
        url: `https://${licenseData.company_url}/s1services`,
        service: "SqlData",
        clientID: thisClientID,
        appId: "1001",
        SqlName: "10022",
        company: licenseData.company_id,
        fromdate: formatDateForAPI(filters.fromdate),
        todate: formatDateForAPI(filters.todate),
        afm: licenseData.afm,
        state: selectedStateIds,
        pagefrom: "1",
        pageto: String(totalRows) // Request all records in one go
      };
  
      console.log("Export parameters:", parameters);
      const response = await axiosInstance.post("/api", parameters);
  
      if (!response?.data?.rows || response.data.rows.length === 0) {
        throw new Error("Received empty data from server");
      }
  
      console.log("Export response:", {
        rowCount: response.data.rows.length,
        firstRow: response.data.rows[0]
      });
  
      // Get table headers (excluding action column)
      const tableHeaders = Array.from(document.querySelectorAll('.table th'))
        .map(th => th.innerText)
        .filter(header => header !== t("action"));
      
      // Prepare data for Excel - with null checks for each field
      const dataForExcel = response.data.rows.map(row => ({
        [t("AA")]: row.AA ?? '-',
        [t("entryDate")]: formatDate(row.TRNDATE ?? ''),
        [t("DocumentCode")]: row.FORTOTIKI ?? '-',
        [t("CustomerDoc")]: row.PARASTATIKOPELATI ?? '-',
        [t("SenderName")]: row.APOSTOLEAS ?? '-',
        [t("RecieverName")]: row.PARALIPTIS ?? '-',
        [t("DeliveryAddress")]: row.SHIPPINGADD ?? '-',
        [t("DeliveryCity")]: row.POLI ?? '-',
        [t("DeliveryStatus")]: row.KATASTASI ?? '-',
        [t("CancellationReason")]: row.AITIAAKIROSIS ?? '-',
        [t("DeliveryRemarks")]: row.DIANOMICOMMENT ?? '-',
      }));
  
      const worksheet = XLSX.utils.json_to_sheet(dataForExcel, { header: tableHeaders });
      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, 'Invoices');
      XLSX.writeFile(workbook, 'invoices.xlsx');
  
    } catch (error) {
      console.error("Export failed:", {
        error: error.message,
        stack: error.stack,
        timestamp: new Date().toISOString()
      });
      alert(`${t("errorExportingData")}: ${error.message}`);
    } finally {
      dispatch(hideLoading());
    }
  };
     

  const formatDate = (dateString) => {
    if (!dateString) return '-'; // Handle missing data
    const date = new Date(dateString);
    if (isNaN(date.getTime())) return '-'; // Handle invalid dates
    
    const day = String(date.getDate()).padStart(2, '0'); // Ensure two digits
    const month = String(date.getMonth() + 1).padStart(2, '0'); // Ensure two digits
    const year = date.getFullYear();
    
    return `${day}/${month}/${year}`;
  };   

  return (
    <div className={`container-fortotikes ${isNavOpen ? 'nav-open' : 'nav-closed'}`}>
      <NavBar toggleNav={toggleNav} />
      <div className="dashboard-content">
        <Header username={username} companyName={companyName} />
        <div className="main-content">
          <h1>{t("fortotikes")}</h1>
          <div className="filters-fortotikes">
            <label>{t("fromDate")}:</label>
            <input
              type="date"
              name="fromdate"
              value={filters.fromdate}
              onChange={handleFilterChange}
              className="filter-input"
            />
            <label>{t("toDate")}:</label>
            <input
              type="date"
              name="todate"
              value={filters.todate}
              onChange={handleFilterChange}
              className="filter-input"
            />
            <Multiselect
              options={stateOptions}
              selectedValues={filters.state}
              onSelect={handleStateSelect}
              onRemove={handleStateRemove}
              displayValue="name"
              placeholder={t("select")}
              className="filter-input muilti-selection"
            />
            <button className="filter-button" onClick={applyFilters}>{t("applyFilters")}</button>
            <button className="export-button" onClick={exportToExcel}>{t("exportToExcel")}</button>
          </div>
          <div className="table-container">
            <table className="table">
              <thead>
                <tr>
                  <th>{t("AA")}</th>
                  <th>{t("entryDate")}</th>
                  <th>{t("DocumentCode")}</th>
                  <th>{t("CustomerDoc")}</th>
                  <th>{t("SenderName")}</th>
                  <th>{t("RecieverName")}</th>
                  <th>{t("DeliveryAddress")}</th>
                  <th>{t("DeliveryCity")}</th>
                  <th>{t("DeliveryStatus")}</th>
                  <th>{t("CancellationReason")}</th>
                  <th>{t("DeliveryRemarks")}</th>
                  <th>{t("action")}</th>
                </tr>
              </thead>
              <tbody>
                {fortotikes.map((fortotiki) => (
                  <tr key={fortotiki.findoc}>
                    <td>{fortotiki.AA || '-'}</td>
                    {/* <td>{fortotiki.TRNDATE || '-'}</td>*/}
                    <td>{formatDate(fortotiki.TRNDATE)}</td>
                    <td>{fortotiki.FORTOTIKI}</td>
                    <td>{fortotiki.PARASTATIKOPELATI || '-'}</td>
                    <td>{fortotiki.APOSTOLEAS || '-'}</td>
                    <td>{fortotiki.PARALIPTIS || '-'}</td>
                    <td>{fortotiki.SHIPPINGADD || '-'}</td>
                    <td>{fortotiki.POLI || '-'}</td>
                    <td>{fortotiki.KATASTASI}</td>
                    <td>{fortotiki.AITIAAKIROSIS || '-'}</td>
                    <td>{fortotiki.DIANOMICOMMENT || '-'}</td>
                    <td style={{alignContent:"center", textAlign: "center"}}>
                      <FaCloudDownloadAlt
                        name="download file"
                        size={20}
                        onClick={() => handlePrintDocument(fortotiki.FINDOC)}
                        className="download-icon"
                      />
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
            <div className="pagination-buttons">
              <button onClick={handlePreviousPage} disabled={currentPage === 1}>
                {t("Previous")}
              </button>
              <span className="paginationSpan">{t("Page")} {currentPage} {t("outOf")} {totalPages}</span>
              <button onClick={handleNextPage} disabled={currentPage === totalPages}>
                {t("Next")}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ListaFortotikon;
